import React from 'react';

/** Small UI atoms shared by SupplierProfilePage tabs. Pure presentational. */

export const Stat = ({ label, value }) => (
  <div className="bg-white/10 backdrop-blur border border-white/20 rounded p-2">
    <div className="text-xs text-blue-100">{label}</div>
    <div className="font-bold mt-0.5">{value}</div>
  </div>
);

export const Highlight = ({ icon: Icon, label, value }) => (
  <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-md">
    <div className="w-8 h-8 rounded bg-blue-100 text-[#2c54b2] flex items-center justify-center shrink-0">
      <Icon className="w-4 h-4" />
    </div>
    <div>
      <div className="text-xs text-gray-500">{label}</div>
      <div className="text-sm font-medium text-gray-900">{value}</div>
    </div>
  </div>
);

export const Fact = ({ label, value }) => (
  <div className="flex justify-between gap-2 border-b border-gray-100 pb-2 last:border-0 last:pb-0">
    <dt className="text-gray-500">{label}</dt>
    <dd className="text-gray-900 font-medium text-right truncate">{value}</dd>
  </div>
);

export const ContactRow = ({ icon: Icon, label, value }) => (
  <div className="flex items-start gap-3">
    <div className="w-9 h-9 rounded-full bg-blue-50 text-[#2c54b2] flex items-center justify-center shrink-0">
      <Icon className="w-4 h-4" />
    </div>
    <div className="min-w-0 flex-1">
      <div className="text-xs text-gray-500">{label}</div>
      <div className="text-sm font-medium text-gray-900 break-words">{value}</div>
    </div>
  </div>
);
